import { AppSpinner, } from '@Components';
import React, { PropsWithChildren, Suspense, } from 'react';

export const Suspended = ({ children, }: PropsWithChildren<{}>) => {
  return <Suspense fallback={<AppSpinner />}>{children}</Suspense>;
};
